import { createSelector } from 'reselect';

// Config
import {
  getKlarnaServiceUnavailableSelector,
  getSelectedPaymentTypeSelector,
} from '../../redux/reducers/payment/paymentSelector';

// Config
import paymentTypeConstants from '../../constants/paymentTypeConstants';

const klarnaConnectMessageState = createSelector(
  [
    getSelectedPaymentTypeSelector,
    getKlarnaServiceUnavailableSelector,
  ],
  (
    selectedPaymentType,
    klarnaServiceUnavailable,
  ) => ({
    showMessage: selectedPaymentType === paymentTypeConstants.KLARNA && klarnaServiceUnavailable,
  }),
);

export default klarnaConnectMessageState;
